import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=0bcb9bfc"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"
import style0 from "./Sessions.vue?vue&type=style&index=0&id=0bcb9bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports